export const messages = {
  labels: {
    startDate: {
      id: 'treatmentSummary.Groups.Other.StartDate',
      defaultMessage: 'Date: ',
    },
    providerName: {
      id: 'treatmentSummary.Groups.Other.ProviderName',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.Other.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.Other.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.Other.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.Other.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
